module.exports = __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmSU5fCRc4AMP6lbBP.8c04242e.woff2";